<template>
  <div id="multiselectbudget">
    <div class="dropdown dropdown-filter" @click="showDropdown">
      <div class="overselect"></div>
      <div class="c-form-input">
        <h3 class="raleway-semi-p13">Nombre de voyageurs</h3>
        <img src="../../images/Fleche haut.svg" v-set-alt v-if="show" />
        <img src="../../images/flechebas-simple.svg" v-set-alt v-else />
      </div>
    </div>
    <div class="multiselect mt-3" v-if="show && !isPhone">
      <div class="adult choice-number row" style="margin-left: 20px">
        <div class="col-4">
          <p class="raleway-reg-p15 mb-0" style="font-size: 13px">Adultes</p>
        </div>
        <div class="col-2" @click="decreaseAdults()">
          <img style="width: 19px;height: 28px;" src="../../images/Moins.svg" v-set-alt />
        </div>
        <div class="col-2">
          <p class="raleway-reg-p15 mb-0">{{ adults }}</p>
        </div>
        <div class="col-2" @click="increaseAdults()">
          <img src="../../images/Plus.svg" style="width: 19px;height: 28px;" v-set-alt />
        </div>
      </div>
      <div class="child choice-number row" style="margin-left: 20px">
        <div class="col-4">
          <p class="raleway-reg-p15 mb-0" style="font-size: 13px">Enfants</p>
        </div>
        <div class="col-2" @click="decreaseChilds()">
          <img style="width: 19px;height: 28px;" src="../../images/Moins.svg" v-set-alt />
        </div>
        <div class="col-2">
          <p class="raleway-reg-p15 mb-0">{{ childs }}</p>
        </div>
        <div class="col-2" @click="increaseChilds()">
          <img style="width: 19px;height: 28px;" src="../../images/Plus.svg" v-set-alt />
        </div>
      </div>
    </div>


    <div class="multiselect mt-3" v-if="show && isPhone">
      <div class="adult choice-number d-flex  border-bottom py-3 border-dark justify-content-between align-items-center">
        <div class="">
          <p class="raleway-reg-p15 mb-0" style="font-size: 13px">Adultes</p>
        </div>
        <div class="d-flex align-items-center">
          <div class="mr-3" @click="decreaseAdults()">
            <img style="width: 19px;height: 28px;" src="../../images/Moins.svg" v-set-alt />
          </div>
          <div class="">
            <p class="raleway-reg-p15 mb-0">{{ adults }}</p>
          </div>
          <div class="ml-3" @click="increaseAdults()">
            <img src="../../images/Plus.svg" style="width: 19px;height: 28px;" v-set-alt />
          </div>
        </div>
      </div>
      <div class="child choice-number d-flex pt-3 justify-content-between align-items-center">
        <div class="  ">
          <p class="raleway-reg-p15 mb-0" style="font-size: 13px">Enfants</p>
        </div>
        <div class="d-flex align-items-center">
          <div class="mr-3" @click="decreaseChilds()">
            <img style="width: 19px;height: 28px;" src="../../images/Moins.svg" v-set-alt />
          </div>
          <div class="">
            <p class="raleway-reg-p15 mb-0">{{ childs }}</p>
          </div>
          <div class="ml-3" @click="increaseChilds()">
            <img style="width: 19px;height: 28px;" src="../../images/Plus.svg" v-set-alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'roomspace',
  components: { },
  props: ['options'],
  data() {
    return {
      childs: 0,
      adults: 2,
      show: false,
      selected: [],
    };
  },
  methods: {
    showDropdown() {
      this.show = !this.show;
    },
    decreaseChilds() {
      if (this.childs > 0) {
        this.childs -= 1;
        this.$emit('changedChilds', this.childs);
        this.$emit("decreaseChilds", this.childs);
      }
    },
    increaseChilds() {
      if (this.childs < 30) {
        this.childs += 1;
        this.$emit('changedChilds', this.childs);
        this.$emit("increaseChilds", this.childs);
      }
    },
    decreaseAdults() {
      if (this.adults > 0) {
        this.adults -= 1;
        this.$emit('changedAdults', this.adults);
        this.$emit("decreaseAdults", this.adults);
      }
    },
    increaseAdults() {
      if (this.adults < 30) {
        this.adults += 1;
        this.$emit('changedAdults', this.adults);
        this.$emit("increaseAdults", this.adults);
      }
    },
  },
  computed: {
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      }else{
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter"></style>
